import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'section-subtitle';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'div', { class: ['section-subtitle__wrapper', ctx.data.staticClass],
                attrs: { 'data-message': ctx.data.attrs && ctx.data.attrs['data-message'] } }, [
                ctx.props.icon && h('i', { class: 'section-subtitle__icon' }, [
                    h(ctx.props.icon, { props: {
                        fill: 'var(--color-icon-02)',
                        secondaryfill: 'var(--color-interactive-04)'
                    }})
                ]),
                h('h4', { class: 'section-subtitle' }, [
                    ctx.slots().default
                ])
            ]
        )
    }
}